<template>
  <div class="tile">
    <div class="alert alert-info"><b>{{ $t('title') }}</b></div>
    <div class="row">
      <div class="col">
        <b-form-group label="ID của cuộc gọi">
          <b-form-input
              v-model="formModel.callId"
              placeholder="ID của cuộc gọi"
              @keyup="getCall(formModel.callId)"
              @paste="handlePaste">
          </b-form-input>
        </b-form-group>
        <div v-if="item && formModel.callId">
          <p class="d-flex justify-content-between align-items-center">
            <b>{{ $t('direction') }}:</b>
            <span class="badge ml-1" :class="iconClass(item)">{{ $t(item.direction) }}</span>
          </p>
          <p class="d-flex justify-content-between">
            <b>{{ $t('client') }}:</b>
            <span v-if="item.client.domain">{{ item.client.domain }}</span>
            <span v-else class="small">{{ $t('notUpdated') }}</span>
          </p>
          <p class="d-flex justify-content-between">
            <b>{{ $t('fromNumber') }}:</b>
            <span v-if="item.fromNumber">{{ item.fromNumber }}</span>
            <span v-else class="small">{{ $t('notUpdated') }}</span>
          </p>
          <p class="d-flex justify-content-between">
            <b>{{ $t('toNumber') }}:</b>
            <span v-if="item.toNumber">{{ item.toNumber }}</span>
            <span v-else class="small">{{ $t('notUpdated') }}</span>
          </p>
          <p class="d-flex justify-content-between">
            <b>{{ $t('startTime') }}:</b>
            <span v-if="item.startTime">{{ item.startTime | moment('HH:mm:ss DD/MM/YYYY') }}</span>
            <span v-else class="small">{{ $t('notUpdated') }}</span>
          </p>
          <p class="d-flex justify-content-between">
            <b>{{ $t('endTime') }}:</b>
            <span v-if="item.endTime">{{ item.endTime | moment('HH:mm:ss DD/MM/YYYY') }}</span>
            <span v-else class="small">{{ $t('notUpdated') }}</span>
          </p>
          <p class="d-flex justify-content-between">
            <b>{{ $t('duration') }}:</b>
            <span>{{ item.duration | callDuration }}</span>
          </p>
          <p class="d-flex justify-content-between">
            <b>{{ $t('billDuration') }}:</b>
            <span>{{ item.billDuration | callDuration }}</span>
          </p>
          <p class="d-flex justify-content-between">
            <b>{{ $t('fileRecording') }}:</b>
            <app-audio v-if="item.recordingDownloaded" :id="item._id" :duration="item.duration"/>
            <span v-else class="small">{{ $t('notUpdated') }}</span>
          </p>
        </div>
        <div v-if="err" class="text-danger">
          {{ $t(err) }}
        </div>
      </div>
      <div class="col" v-if="item && formModel.callId">
        <b-form-group :label="$t('file')"
                      :invalid-feedback="errorTxt"
                      :state="state">
          <b-form-file
              v-model="formModel.file"
              :placeholder="$t('filePlaceholder')"
              :accept="accept"
              :state="state"
              @input="change">
          </b-form-file>
          <button :disabled="!formModel.file || errorTxt" @click="upload" class="btn btn-primary mt-1 float-right">
            {{ $t('upload') }}
          </button>
        </b-form-group>
      </div>
    </div>
  </div>
</template>

<script>
import AppAudio from "@/components/AppAudio.vue";

export default {
  components: {AppAudio},
  data() {
    return {
      formModel: {
        callId: '',
        file: null,
      },
      err: null,
      service: '/call',
      item: null,
      accept: 'audio/mpeg',
      state: null,
      errorTxt: '',
      // maxSize: 10,
    }
  },
  methods: {
    getCall(id) {
      this.$bgService.get(this.service + `/${id}`)
          .then(res => {
            if (res.data) {
              this.item = res.data;
            }
            this.err = null;
          })
          .catch(() => {
            this.err = this.$t('notFound');
            this.item = null;
          })
    },
    upload() {
      let loader = this.$loading.show();
      const formData = new FormData();
      formData.append('file', this.formModel.file);
      this.$service.post(this.service + `/${this.formModel.callId}/recording`, formData)
          .then(() => {
            this.$swal({
              title: this.$t('success'),
              text: this.$t('uploadSuccess'),
              icon: 'success'
            });
          })
          .catch(err => {
            this.$swal({
              title: this.$t('error'),
              text: err.response.data.message,
              icon: 'error'
            });
          })
          .finally(() => {
            this.formModel.file = null;
            loader.hide();
          });
      this.getCall(this.formModel.callId);
    },
    change() {
      this.state = null;
      this.errorTxt = null;
      if (this.accept && !this.accept.split(',').includes(this.formModel.file.type)) {
        this.state = false;
        this.errorTxt = this.$t('invalidType');
      }
      // else if (this.formModel.file.size / (1024 * 1024) > this.maxSize) {
      //   this.state = false;
      //   this.errorTxt = this.$t('maxSizeExceeded');
      // }
    },
    iconClass(item) {
      if (item.hangupCause === 'NORMAL_CLEARING') {
        return 'badge-success';
      } else {
        return 'badge-danger';
      }
    },
    handlePaste(event) {
      const pastedText = (event.clipboardData || window.clipboardData).getData('text');
      this.getCall(pastedText);
    }
  },
  i18n: {
    messages: {
      en: {
        filePlaceholder: 'MP3 file',
        notFound: 'Call not found, please enter correct ID',
        file: 'Select file',
        title: 'Upload recording file',
        callDetail: 'Call detail',
        hangupCause: 'End status',
        fromNumber: 'Outgoing phone number',
        toNumber: 'Incoming phone number',
        startTime: 'Start',
        endTime: 'End',
        duration: 'Duration',
        billDuration: 'Talk duration',
        missCall: 'Miss call',
        fileRecording: 'Recording file',
        direction: 'Direction',
        uploadSuccess: 'Uploaded successfully',
        invalidType: "Invalid file type",
        maxSizeExceeded: "Max file size exceeded",
        upload: 'Upload',
      },
      vi: {
        filePlaceholder: 'Định dạng mp3',
        notFound: 'Không tìm thấy cuộc gọi, vui lòng nhập đúng ID',
        file: 'Chọn file',
        title: 'Tải lên tập tin ghi âm',
        callDetail: 'Chi tiết cuộc gọi',
        hangupCause: 'Kết quả',
        fromNumber: 'Số gọi đi',
        toNumber: 'Số gọi đến',
        startTime: 'Bắt đầu',
        endTime: 'Kết thúc',
        duration: 'Tổng thời gian',
        billDuration: 'Đàm thoại',
        missCall: 'Gọi nhỡ',
        fileRecording: 'Tập tin ghi âm',
        direction: 'Hướng gọi',
        uploadSuccess: 'Tải lên tập tin ghi âm thành công',
        invalidType: "Loại tập tin không hợp lệ",
        maxSizeExceeded: "Vượt quá kích thước tệp tối đa",
        upload: 'Tải lên',
      }
    }
  }
}
</script>